import { useState } from 'react';
import { useI18n } from '../i18n/I18nContext';
import { Button, Field } from './components';

export const OfficialHandoffReceipt = ({ load }: { load: (intentId?: string) => Promise<string> }) => {
  const { t } = useI18n();
  const [receipt, setReceipt] = useState('');
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  const [intentId, setIntentId] = useState('');
  const obtain = async () => {
    setBusy(true); setFailed(false); setReceipt('');
    try { setReceipt(await load(intentId.trim() || undefined)); } catch { setFailed(true); }
    finally { setBusy(false); }
  };
  return <div className="handoff-receipt-panel">
    <p>{t('handoff.exportHelp')}</p>
    <Field label={t('handoff.exportReference')} value={intentId} disabled={busy}
      onChange={event => { setIntentId(event.target.value); setReceipt(''); setFailed(false); }} />
    <Button variant="ghost" disabled={busy} onClick={() => void obtain()}>{t('handoff.exportObtain')}</Button>
    {failed ? <p role="alert">{t('handoff.exportUnavailable')}</p> : null}
    {receipt ? <label>{t('handoff.exportLabel')}<textarea readOnly value={receipt} onFocus={event => event.currentTarget.select()} /></label> : null}
  </div>;
};
